import React from 'react';
import { AttachMediaModal } from '../../../../components/AttachMediaModal';
import { ElementWrapper } from '../../../../components/ElementWrapper';
import { IElement } from '../../../../models/Element';
import { HomeImageRightDescriptionContent } from './HomeImageRightDescriptionContent';
import { HomeImageRightDescriptionElement } from './HomeImageRightDescriptionElement';
import { HomeImageRightDescriptionFigure } from './HomeImageRightDescriptionFigure';

interface HomeImageRightDescriptionProps {
  index: number;
  data: HomeImageRightDescriptionElement;
  updateData: (element: IElement, index: number) => void;
}

export const HomeImageRightDescriptionFC: React.FC<
  HomeImageRightDescriptionProps
> = ({ index, data, updateData }) => {
  const update = (
    fieldsToUpdate: Partial<HomeImageRightDescriptionElement>
  ) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <>
      <AttachMediaModal
        modalId={`${data.name}-${data.id}`}
        updateCallback={(image, image_alt) =>
          update({ image_preview: image, image_preview_alt: image_alt })
        }
      />

      <ElementWrapper elementIndex={index}>
        <div className="home-image-right-description">
          <div className="position-relative align-items-center showcase">
            <HomeImageRightDescriptionContent data={data} update={update} />
            <HomeImageRightDescriptionFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
